import {
  CloseOutlined,
  LeftCircleOutlined,
  RightCircleOutlined,
} from "@ant-design/icons";
import { Button, Form, Input, Select, Typography } from "antd";
import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  DeleteOrderDraft,
  PDetailsPrice,
  PlaceOrderRequest,
} from "../../../redux/actions/adminActions/newOrderRequestAction";
import { AllProductsAPI } from "../../../redux/actions/adminActions/allProductsAction";
import Alertify from "../../../services/alertify";
import { useLocation } from "wouter";
import { resetAdminDealers } from "../../../redux/reducers/adminReducers/adminDealersSlice";
import { getQueryParams } from "../../../utilities/getQueryParams";

const { Title } = Typography;

const ProductAndPaymentDuplicate = (props) => {
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const [, setProducts] = useState([{ pad: 0 }]);
  const [isChange, setIsChange] = useState(false);
  const [, setLocation] = useLocation();
  const [errorMessages, setErrorMessages] = useState({}); // for discount error
  const [quantityErrorMessage, setQuantityErrorMessage] = useState({}); // for Quantity less than 1 error
  const [gtError, setGtError] = useState(); // for Grand Total error
  const [fPercent, setFPercent] = useState(); //for freight percent greater than 100 error
  const [freightType, setFreightType] = useState("");
  const [disabledSubmit, setDisabledSubmit] = useState(false);

  const handleSubmit = () => {
    setDisabledSubmit(true);

    const formValues = form.getFieldsValue();
    const products = formValues.products || [];
    // Convert relevant fields to numbers
    const convertedProducts = products.map((product) => ({
      ...product,
      packaging_quantity_wholesaler_box: Number(
        product.packaging_quantity_wholesaler_box
      ),
      unit_price: Number(product.unit_price),
      msp: Number(product.msp),
      boxPrice: Number(product.boxPrice),
      quantity: Number(product.quantity),
      total_price: Number(product.total_price),
      discount: Number(product.discount),
      pad: Number(product.pad),
      gst: Number(product.gst),
      gstNumber: Number(product.gstNumber),
      final_price: Number(product.final_price),
    }));

    const subTotal = Number(formValues.subTotal);
    const totalGST = Number(formValues.totalGST);
    const grandTotal = Number(formValues.grandTotal);
    const params = getQueryParams();
    const uuIds = params.UUID;
    // const freight_percent = Number(formValues.freight_percent);
    // Update form values with converted numbers
    const freight_percent = isNaN(Number(formValues.freight_percent))
      ? 0
      : Number(formValues.freight_percent);
    form.setFieldsValue({
      products: convertedProducts,
      subTotal,
      totalGST,
      grandTotal,
      freight_percent,
    });

    const newErrorMessages = {};
    const quantityError = {};
    let hasError = false;

    convertedProducts.forEach((product, index) => {
      const min_price =
        product.packaging_quantity_wholesaler_box *
        product.msp *
        product.quantity;
      const pad = product.pad;
      if (pad < min_price) {
        newErrorMessages[
          index
        ] = `Price after discount is less than the minimum price.`;
        hasError = true;
      } else if (product.quantity < 1) {
        quantityError[index] = `Qunatity should be atleast 1.`;
        setDisabledSubmit(true);
        hasError = true;
      } else {
        const grand_Total = Number(formValues.grandTotal);
        const balanced_credit_limit = Number(formValues.balance_credit);

        if (
          props.formData.orderType !== "Blanket Order" &&
          grand_Total > balanced_credit_limit
        ) {
          var grandTotalError = `Grand Total should be less than or Equal to the Balanced Credit Limit.`;
          hasError = true;
          setGtError(grandTotalError);
          setDisabledSubmit(true);
          return;
        }
      }
    });

    setErrorMessages(newErrorMessages);
    setQuantityErrorMessage(quantityError);

    if (hasError) {
      return;
    }
    const freight_percent_value = Number(form.getFieldValue("freight_percent"));
    if (freight_percent_value > 100) {
      setFPercent(
        "The Freight Percentage should be less than or equal to 100."
      );
      setDisabledSubmit(true);
    }
    form
      .validateFields()
      .then((values) => {
        // console.log("Form Values:", updatedFormData);
        const updatedFormData = { ...props.formData, ...values };
        if (freightType === "Freight As per Customer PO") {
          updatedFormData.subsidy = null;
        }
        if (freightType === "Freight Added to Invoice") {
          updatedFormData.freight_percent = null;
        }
        dispatch(PlaceOrderRequest(updatedFormData))
          .then((response) => {
            const order_sent_status =
              response?.payload?.data?.erp_response.responses[0]?.status;
            console.log("Response is ++++++++++++++++:", updatedFormData);
            props.setFormData({});
            dispatch(resetAdminDealers());
            console.log("props.formData-----------------", props.formData);
            if (order_sent_status === 400) {
              Alertify.error("Order failed!");
              setLocation("/admin/failed-orders");
            } else {
              Alertify.success("Order placed successfully!");
              setLocation("/admin/orders");
            }
            // add draft order delete API
            if (uuIds) {
              const draftDeleteReqData = {
                uuid: uuIds,
              };
              dispatch(DeleteOrderDraft(draftDeleteReqData));
            }
          })
          .catch((error) => {
            console.error("Error Place Order Request:", error);
          });
        // props.onNext(values);
      })
      .catch((errorInfo) => {
        console.error("Validation Failed:", errorInfo);
        Alertify.error("Please fill in all required fields.");
      });
  };

  const handleDraft = () => {
    form
      .validateFields()
      .then((values) => {
        console.log("Form Values:", values);
        props.onNext(values);
        window.history.back();
      })
      .catch((errorInfo) => {
        console.error("Validation Failed:", errorInfo);
        Alertify.error("Please fill in all required fields.");
      });
  };

  const searchProduct = (value, fieldName) => {
    // console.log("Formadata is:", props.formData);
    const data = {
      erp_item_code: value,
      dealer_code: props.formData.dealer_code,
    };
    dispatch(PDetailsPrice(data))
      .then((response) => {
        const productDetails = response.payload?.data?.data;
        const box_price = parseFloat(
          parseFloat(productDetails.pricing.unit_price) *
            parseFloat(productDetails.product.packaging_quantity_wholesaler_box)
        );
        const gst_amount =
          (parseFloat(productDetails.product.gst) * box_price) / 100;
        const price_after_gst = parseFloat(box_price) + parseFloat(gst_amount);
        console.log("price_after_gst----------", price_after_gst);
        console.log(
          "productDetails.product.gst----------",
          productDetails.product.gst
        );
        console.log("box_price----------", box_price);
        const currentSections = form.getFieldValue("products");
        const updatedSections = currentSections.map((section, index) =>
          index === fieldName
            ? {
                ...section,
                alp_code: productDetails.product.erp_item_code,
                title:
                  productDetails.product.title +
                  "-" +
                  productDetails.product.erp_item_code,
                packaging_quantity_wholesaler_box:
                  productDetails.product.packaging_quantity_wholesaler_box,
                unit_price: productDetails.pricing.unit_price,
                boxPrice: box_price.toFixed(5),
                quantity: 1,
                discount: 0,
                total_price: box_price.toFixed(5),
                pad: box_price.toFixed(5),
                gst: productDetails.product.gst,
                gstNumber: (productDetails.product.gst * box_price) / 100,
                final_price: price_after_gst.toFixed(5),
                msp: productDetails.pricing.msp_price,
              }
            : section
        );

        form.setFieldsValue({
          products: updatedSections,
        });
        setProducts(updatedSections);
        setIsChange(true);
      })
      .catch((error) => {
        console.error("Error fetching product details:", error);
      });
  };

  useEffect(() => {
    dispatch(AllProductsAPI({ dealer_code: props.formData.dealer_code }))
      .then((response) => {
        // Handle response if needed
      })
      .catch((error) => {
        console.error("Error fetching the products;", error);
      });
  }, [dispatch]);

  useEffect(() => {
    form.setFieldsValue({
      payment_method: props.formData.transaction_type,
      balance_credit: props.formData.balance_credit,
      // boxPrice: box_price,
    });
  }, [form, props.formData]);
  const [subTotalValue, setSubTotalValue] = useState({
    subTotal: "",
    grandTotal: "",
    totalGST: "",
  });
  // Autofill data from props.formData into the form fields
  useEffect(() => {
    if (Array.isArray(props.formData.products))
      form.setFieldsValue({
        products: props.formData.products?.map((product) => ({
          boxPrice: parseFloat(
            parseFloat(product.unit_price) *
              parseFloat(product.packaging_quantity_wholesaler_box)
          ).toFixed(5),
          alp_code: product.alp_code,
          title: product.title,
          packaging_quantity_wholesaler_box:
            product.packaging_quantity_wholesaler_box,
          gst: product.gst,
          quantity: product.quantity,
          unit_price: parseFloat(product.unit_price).toFixed(5),
          final_price: parseFloat(
            (product.gst *
              (parseFloat(product.unit_price) *
                parseFloat(product.packaging_quantity_wholesaler_box) *
                product.quantity -
                (product.discount *
                  (parseFloat(product.unit_price) *
                    parseFloat(product.packaging_quantity_wholesaler_box) *
                    product.quantity)) /
                  100)) /
              100 +
              (parseFloat(product.unit_price) *
                parseFloat(product.packaging_quantity_wholesaler_box) *
                product.quantity -
                (product.discount *
                  (parseFloat(product.unit_price) *
                    parseFloat(product.packaging_quantity_wholesaler_box) *
                    product.quantity)) /
                  100)
          ).toFixed(5),
          discount: product.discount,
          total_price: parseFloat(
            parseFloat(product.unit_price) *
              parseFloat(product.packaging_quantity_wholesaler_box) *
              product.quantity
          ).toFixed(5),
          pad: parseFloat(
            parseFloat(product.unit_price) *
              parseFloat(product.packaging_quantity_wholesaler_box) *
              product.quantity -
              (product.discount *
                (parseFloat(product.unit_price) *
                  parseFloat(product.packaging_quantity_wholesaler_box) *
                  product.quantity)) /
                100
          ).toFixed(5),
          gstNumber:
            (product.gst *
              (parseFloat(product.unit_price) *
                parseFloat(product.packaging_quantity_wholesaler_box))) /
            100,
          msp: product.msp,
        })),
      });

    const currentSections = form.getFieldValue("products") || [];
    setProducts(currentSections);
    const subTotal = currentSections.reduce(
      (acc, section) => acc + parseFloat(section.pad || 0),
      0
    );
    const grandTotal = currentSections.reduce(
      (acc, section) => acc + parseFloat(section.final_price || 0),
      0
    );
    const totalGST = currentSections.reduce(
      (acc, section) => acc + parseFloat(section.gstNumber || 0),
      0
    );
    setSubTotalValue({
      subTotal: subTotal.toFixed(2),
      grandTotal: grandTotal.toFixed(2),
      totalGST: totalGST.toFixed(2),
    });
    const freight_percent_value = Number(form.getFieldValue("freight_percent"));
    const grand_Total = Number(grandTotal);
    const balanced_credit_limit = Number(form.getFieldValue("balance_credit"));

    if (
      props.formData.orderType !== "Blanket Order" &&
      grand_Total > balanced_credit_limit
    ) {
      var grandTotalError = `Grand Total should be less than or Equal to the Balanced Credit Limit.`;
      setGtError(grandTotalError);
      console.log(
        `props.formData.balance_credit:::::::::${props.formData.balance_credit}`
      );
      setDisabledSubmit(true);
    } else if (freight_percent_value > 100) {
      setFPercent(
        "The Freight Percentage should be less than or equal to 100."
      );
      setDisabledSubmit(true);
    } else {
      setGtError(null);
      setDisabledSubmit(false);
      setFPercent(null);
    }
  }, [form, props.formData]);
  const allProducts = useSelector((state) => state.all_product);

  const all_products_options = useMemo(() => {
    return allProducts.all_products_slice || [];
  }, [allProducts]);

  const quantityChange = (value, fieldName) => {
    const currentSections = form.getFieldValue("products");
    const currentSection = currentSections[fieldName];
    if (value < 1) {
      Alertify.error("Minimum quantity should be 1.");
      return;
    }
    if (currentSection) {
      const boxPrice = currentSection.boxPrice || 0;
      const quantity = parseFloat(value) || 0;
      const total_price = parseFloat(boxPrice * quantity).toFixed(5);
      const discount = currentSection.discount;
      const totalDiscount = (discount * total_price) / 100;
      const pad = parseFloat((total_price - totalDiscount).toFixed(5));
      const gst = parseFloat(currentSection.gst);
      const gstNumber = parseFloat((gst * pad) / 100);
      const final_price = parseFloat((gst * pad) / 100 + pad).toFixed(5);
      form.setFieldsValue({
        products: currentSections.map((section, index) =>
          index === fieldName
            ? { ...section, quantity, total_price, pad, final_price, gstNumber }
            : section
        ),
      });
    }
  };

  const discountChange = (value, fieldName) => {
    console.log(typeof value);
    if (value >= 100) {
      Alertify.error("Discount should be less than 100%.");
      return;
    }
    const currentSections = form.getFieldValue("products");
    const currentSection = currentSections[fieldName];
    if (currentSection) {
      const discount = value;
      const total_price =
        parseFloat(currentSection.total_price).toFixed(5) || 0;
      const min_price =
        parseFloat(currentSection.packaging_quantity_wholesaler_box) *
        parseFloat(currentSection.msp) *
        parseFloat(currentSection.quantity);
      var pad = parseFloat(
        (total_price - (discount * total_price) / 100).toFixed(5)
      );
      const gst = parseFloat(currentSection.gst);
      const gstNumber = parseFloat((gst * pad) / 100).toFixed(5);

      const final_price = parseFloat((gst * pad) / 100 + pad).toFixed(5);
      if (pad < min_price) {
        const max_discount = parseFloat(100 - (min_price / total_price) * 100);
        Alertify.error("This discount is not allowed on this product.");
        pad = 0;
        form.setFieldsValue({
          products: currentSections.map((section, index) =>
            index === fieldName ? { ...section, pad } : section
          ),
        });
        return;
      }
      form.setFieldsValue({
        products: currentSections.map((section, index) =>
          index === fieldName
            ? { ...section, discount, pad, final_price, gstNumber }
            : section
        ),
      });
    }
  };

  useEffect(() => {
    if (isChange) {
      const currentSections = form.getFieldValue("products") || [];
      setProducts(currentSections);
      const subTotal = currentSections.reduce(
        (acc, section) => acc + parseFloat(section.pad || 0),
        0
      );
      const grandTotal = currentSections.reduce(
        (acc, section) => acc + parseFloat(section.final_price || 0),
        0
      );
      const totalGST = currentSections.reduce(
        (acc, section) => acc + parseFloat(section.gstNumber || 0),
        0
      );
      setSubTotalValue({
        subTotal: subTotal.toFixed(2),
        grandTotal: grandTotal.toFixed(2),
        totalGST: totalGST.toFixed(2),
      });
      const freight_percent_value = Number(
        form.getFieldValue("freight_percent")
      );
      const grand_Total = Number(grandTotal);
      const balanced_credit_limit = Number(
        form.getFieldValue("balance_credit")
      );
      if (
        props.formData.orderType !== "Blanket Order" &&
        grand_Total > balanced_credit_limit
      ) {
        var grandTotalError = `Grand Total should be less than or Equal to the Balanced Credit Limit.`;
        setGtError(grandTotalError);
        setDisabledSubmit(true);
      } else if (freight_percent_value > 100) {
        setFPercent(
          "The Freight Percentage should be less than or equal to 100."
        );
        setDisabledSubmit(true);
      } else {
        setGtError(null);
        setDisabledSubmit(false);
        setFPercent(null);
      }
      // console.log("subtotalValue is:-------------------", subTotal);
      // console.log("Section is:-------------------", products);
      setIsChange(false);
    }
  }, [form, isChange]);

  useEffect(() => {
    form.setFieldsValue({
      subTotal: subTotalValue?.subTotal,
      grandTotal: subTotalValue?.grandTotal,
      totalGST: subTotalValue?.totalGST,
    });
    setIsChange(false);
  }, [form, subTotalValue]);

  const handleValueChange = () => {
    const currentSections = form.getFieldValue("products") || [];
    setProducts(currentSections);
    const subTotal = currentSections?.reduce(
      (acc, section) => acc + parseFloat(section.pad || 0),
      0
    );
    const grandTotal = currentSections.reduce(
      (acc, section) => acc + parseFloat(section.final_price || 0),
      0
    );
    const totalGST = currentSections.reduce(
      (acc, section) => acc + parseFloat(section.gstNumber || 0),
      0
    );

    const newErrorMessages = {};
    const quantityError = {};
    let hasError = false;

    currentSections.forEach((product, index) => {
      const min_price =
        product.packaging_quantity_wholesaler_box *
        product.msp *
        product.quantity;
      // const pad = product.pad;
      const pad = parseFloat(
        (
          product.packaging_quantity_wholesaler_box *
            product.unit_price *
            product.quantity -
          (product.discount *
            product.packaging_quantity_wholesaler_box *
            product.unit_price *
            product.quantity) /
            100
        ).toFixed(2)
      );
      const freight_percent_value = Number(
        form.getFieldValue("freight_percent")
      );
      const grand_Total = Number(grandTotal);
      const balanced_credit_limit = Number(
        form.getFieldValue("balance_credit")
      );
      if (pad < min_price) {
        newErrorMessages[
          index
        ] = `Price after discount is less than the minimum price.`;
        hasError = true;
        setDisabledSubmit(true);
        return;
      } else if (product.quantity < 1) {
        quantityError[index] = `Qunatity should be atleast 1.`;
        setDisabledSubmit(true);
        hasError = true;
      } else if (
        props.formData.orderType !== "Blanket Order" &&
        grand_Total > balanced_credit_limit
      ) {
        var grandTotalError = `Grand Total should be less than or Equal to the Balanced Credit Limit.`;
        hasError = true;
        setGtError(grandTotalError);
        setDisabledSubmit(true);
      } else if (freight_percent_value > 100) {
        setFPercent(
          "The Freight Percentage should be less than or equal to 100."
        );
        setDisabledSubmit(true);
      } else {
        setGtError(null);
        setDisabledSubmit(false);
        setFPercent(null);
      }
    });

    setErrorMessages(newErrorMessages);
    setQuantityErrorMessage(quantityError);

    if (!hasError) {
      setErrorMessages({});
      setQuantityErrorMessage({});
    }
    form.setFieldsValue({
      subTotal: subTotal.toFixed(5),
      grandTotal: grandTotal.toFixed(5),
      totalGST: totalGST.toFixed(5),
    });
  };
  const handlePrevious = () => {
    const formValues = form.getFieldsValue();
    const products = formValues.products || [];
    // Convert relevant fields to numbers
    const convertedProducts = products.map((product) => ({
      ...product,
      packaging_quantity_wholesaler_box: Number(
        product.packaging_quantity_wholesaler_box
      ),
      unit_price: Number(product.unit_price).toFixed(5),
      msp: Number(product.msp),
      boxPrice: Number(product.boxPrice).toFixed(5),
      quantity: Number(product.quantity),
      total_price: Number(product.total_price).toFixed(5),
      discount: Number(product.discount),
      pad: Number(product.pad).toFixed(5),
      gst: Number(product.gst),
      gstNumber: Number(product.gstNumber),
      final_price: Number(product.final_price).toFixed(5),
    }));

    const subTotal = Number(formValues.subTotal);
    const totalGST = Number(formValues.totalGST);
    const grandTotal = Number(formValues.grandTotal);
    // const freight_percent = Number(formValues.freight_percent);

    // Update form values with converted numbers
    const freight_percent = isNaN(Number(formValues.freight_percent))
      ? 0
      : Number(formValues.freight_percent);
    form.setFieldsValue({
      products: convertedProducts,
      subTotal,
      totalGST,
      grandTotal,
      freight_percent,
    });

    const values = form.getFieldsValue();
    console.log("Form Values:", values);
    props.handlePrev(values);
  };

  const handleFreightChange = (value) => {
    setFreightType(value);
    console.log("freightType is -----------------", value);
  };

  return (
    <>
      <div className="border rounded-lg p-4 w-full">
        <Form
          form={form}
          layout="vertical"
          className="text-left"
          onFinish={handleSubmit}
          onValuesChange={handleValueChange}
          initialValues={{ remember: true, products: [{ pad: 0 }] }}
        >
          <div className="border p-4 rounded-lg">
            <Title level={3} className="text-left py-4">
              Order Details
            </Title>

            <Form.List name="products">
              {(fields, { add, remove }) => (
                <>
                  {fields.map(({ key, name: fieldName }) => (
                    <div
                      key={key}
                      className="add relative border p-4 rounded-lg mb-5 bg-slate-50"
                    >
                      {fields.length > 1 && (
                        <Button
                          type="text"
                          icon={<CloseOutlined />}
                          className="absolute right-1 top-1 h-[20px] w-[20px]"
                          onClick={() => remove(fieldName)}
                        />
                      )}
                      <div className="sm:flex">
                        <div className="w-full sm:me-4">
                          <Form.Item
                            label="Title"
                            name={[fieldName, "alp_code"]}
                            rules={[
                              {
                                required: true,
                                message: "Please select Product!",
                              },
                            ]}
                          >
                            <Select
                              showSearch
                              placeholder="Select Product"
                              onChange={(value) => {
                                searchProduct(value, fieldName);
                                setIsChange(true);
                              }}
                              filterOption={
                                (input, option) =>
                                  option?.name
                                    ?.toLowerCase()
                                    .includes(input.toLowerCase()) || // Check the name
                                  option?.value
                                    ?.toLowerCase()
                                    .includes(input.toLowerCase()) // Check the value (ERP code)
                              }
                              options={all_products_options.map((items) => ({
                                key: `${items.erp_item_code}`,
                                value: `${items.erp_item_code}`,
                                name: items.name, // Add the name as a property for easy search
                                label: (
                                  <div
                                    className={`flex justify-between p-2 ${
                                      items.is_expired === 1
                                        ? "bg-gray-100"
                                        : ""
                                    }`}
                                  >
                                    <div className="flex">
                                      {items.name},{" "}
                                      {items.erp_item_code.toUpperCase()}
                                    </div>
                                    {items.is_expired === 1 && (
                                      <div
                                        className="ant-tag ant-tag-volcano css-dev-only-do-not-override-1oemflq m-0"
                                        style={{ color: "red" }}
                                      >
                                        Expired
                                      </div>
                                    )}
                                  </div>
                                ),
                                // label: `${items.name}, ${items.erp_item_code},${items.is_expired === 1 && "Expired"}`,
                                disabled: items.is_expired === 1, // Disable if expired
                              }))}
                            />
                          </Form.Item>

                          <Form.Item
                            className="hidden"
                            label="Title"
                            name={[fieldName, "title"]}
                          >
                            <Input placeholder="title" disabled />
                          </Form.Item>
                        </div>
                        <div className="w-full sm:flex ">
                          <Form.Item
                            className="sm:me-4"
                            label="Pack Of"
                            name={[
                              fieldName,
                              "packaging_quantity_wholesaler_box",
                            ]}
                          >
                            <Input
                              placeholder="pack of"
                              type="number"
                              disabled
                            />
                          </Form.Item>
                          <Form.Item
                            className="sm:me-4"
                            label="Unit Price"
                            name={[fieldName, "unit_price"]}
                          >
                            <Input
                              placeholder="Unit Price"
                              type="number"
                              disabled
                            />
                          </Form.Item>
                          <Form.Item
                            className="hidden"
                            label="MSP"
                            name={[fieldName, "msp"]}
                          >
                            <Input placeholder="MSP" type="number" disabled />
                          </Form.Item>
                          <Form.Item
                            label="Box Price"
                            name={[fieldName, "boxPrice"]}
                          >
                            <Input
                              placeholder="Box Price"
                              type="number"
                              disabled
                            />
                          </Form.Item>
                        </div>
                      </div>
                      <div className="w-full sm:flex ">
                        <Form.Item
                          className="sm:me-4"
                          label="Quantity(No. of Boxes)"
                          name={[fieldName, "quantity"]}
                          validateStatus={
                            quantityErrorMessage[fieldName] ? "error" : ""
                          }
                          help={quantityErrorMessage[fieldName]}
                        >
                          <Input
                            placeholder="Number of Boxes"
                            type="number"
                            onChange={(e) => {
                              quantityChange(e.target.value, fieldName);
                              setIsChange(true);
                            }}
                          />
                        </Form.Item>
                        <Form.Item
                          className="sm:me-4"
                          label="Total Price"
                          name={[fieldName, "total_price"]}
                        >
                          <Input
                            placeholder="Total Price"
                            type="number"
                            disabled
                          />
                        </Form.Item>
                        <Form.Item
                          label="Discount"
                          name={[fieldName, "discount"]}
                          className="sm:me-4 sm:w-[16.67%]"
                          validateStatus={
                            errorMessages[fieldName] ? "error" : ""
                          }
                          help={errorMessages[fieldName]}
                        >
                          <Input
                            placeholder="Discount"
                            type="text"
                            step="0.00001"
                            onChange={(e) => {
                              let value = e.target.value;
                              // Allow any number of digits before decimal and up to 5 after
                              if (
                                value === "" ||
                                /^\d*\.?\d{0,5}$/.test(value)
                              ) {
                                discountChange(value, fieldName);
                                setIsChange(true);
                              }
                            }}
                            onKeyDown={(e) => {
                              const charStr = e.key;
                              const currentValue = e.target.value;
                              const cursorPosition = e.target.selectionStart;

                              // Allow navigation keys
                              if (
                                [
                                  "Backspace",
                                  "Delete",
                                  "ArrowLeft",
                                  "ArrowRight",
                                  "Tab",
                                ].includes(charStr)
                              ) {
                                return;
                              }

                              // Only allow digits and one decimal point
                              if (!/[\d.]/.test(charStr)) {
                                e.preventDefault();
                                return;
                              }

                              // Prevent multiple decimal points
                              if (
                                charStr === "." &&
                                currentValue.includes(".")
                              ) {
                                e.preventDefault();
                                return;
                              }

                              // Only limit decimal places if cursor is after decimal point
                              if (currentValue.includes(".")) {
                                const parts = currentValue.split(".");
                                const decimalPart = parts[1];
                                const decimalPosition = parts[0].length + 1;

                                // Only restrict if we're adding to the decimal part and it already has 5 digits
                                if (
                                  cursorPosition >= decimalPosition &&
                                  decimalPart.length >= 5
                                ) {
                                  e.preventDefault();
                                }
                              }
                            }}
                          />
                        </Form.Item>
                        <Form.Item
                          className="sm:me-4"
                          label="Price After Discount"
                          name={[fieldName, "pad"]}
                        >
                          <Input
                            placeholder="Price After Discount"
                            type="number"
                            disabled
                          />
                        </Form.Item>
                        <Form.Item
                          className="sm:me-4"
                          label="GST"
                          name={[fieldName, "gst"]}
                        >
                          <Input placeholder="GST" type="number" disabled />
                        </Form.Item>
                        <Form.Item
                          className="hidden"
                          label="GST Number"
                          name={[fieldName, "gstNumber"]}
                        >
                          <Input
                            placeholder="GST Number"
                            type="number"
                            disabled
                          />
                        </Form.Item>
                        <Form.Item
                          label="Price After GST"
                          name={[fieldName, "final_price"]}
                        >
                          <Input
                            placeholder="Price After GST"
                            type="number"
                            disabled
                          />
                        </Form.Item>
                      </div>
                    </div>
                  ))}
                  <Form.Item className="mt-5 flex justify-center">
                    <Button
                      className="Paragraph-white border"
                      onClick={() => add({ pad: 0 })}
                    >
                      Add Product
                    </Button>
                  </Form.Item>
                </>
              )}
            </Form.List>
          </div>
          <div className="border p-4 rounded-lg mt-4">
            <Title level={3} className="text-left py-4">
              Payment Details
            </Title>
            <div className="sm:flex">
              <div className="w-full sm:me-4">
                <Form.Item
                  label="Freight Type"
                  name="freight_type"
                  rules={[
                    {
                      required: true,
                      message: "Please select Freight Type",
                    },
                  ]}
                >
                  <Select
                    showSearch
                    placeholder="Select Freight Type"
                    filterOption={(input, option) =>
                      (option?.label ?? "")
                        .toLowerCase()
                        .includes(input.toLowerCase())
                    }
                    onChange={(value) => handleFreightChange(value)}
                    options={[
                      {
                        value: "Freight to Pay by Customer",
                        label: "Freight to Pay by Customer",
                      },
                      {
                        value: "Freight As per Customer PO",
                        label: "Freight As per Customer PO",
                      },
                      {
                        value: "Freight Added to Invoice",
                        label: "Freight Added to Invoice",
                      },
                    ]}
                  />
                </Form.Item>
              </div>
              <div className="w-full sm:me-4">
                {freightType === "Freight As per Customer PO" && (
                  <Form.Item
                    className="sm:me-4"
                    label="Freight Percent"
                    name="freight_percent"
                    validateStatus={fPercent ? "error" : ""}
                    help={fPercent}
                    rules={[
                      {
                        required: true,
                        message: "Please type Freight Percent",
                      },
                    ]}
                  >
                    <Input placeholder="Freight Percent" type="number" />
                  </Form.Item>
                )}
                {freightType === "Freight Added to Invoice" && (
                  <Form.Item
                    className="sm:me-4"
                    label="Freight Subsidy"
                    name="subsidy"
                  >
                    <Select
                      showSearch
                      placeholder="Select Freight Subsidy"
                      filterOption={(input, option) =>
                        (option?.label ?? "")
                          .toLowerCase()
                          .includes(input.toLowerCase())
                      }
                      options={[
                        { value: "", label: "0%" },
                        { value: "10%", label: "10%" },
                        { value: "20%", label: "20%" },
                        { value: "30%", label: "30%" },
                        { value: "40%", label: "40%" },
                        { value: "50%", label: "50%" },
                        { value: "100%", label: "100%" },
                      ]}
                    />
                  </Form.Item>
                )}
              </div>
              <div className="w-full sm:me-4"></div>
            </div>
            <div className="w-full sm:flex">
              <div className="w-full">
                <Form.Item
                  className="sm:me-4"
                  label="Total Weight"
                  name="totalWeight"
                >
                  <Input placeholder="Total Weight" type="number" disabled />
                </Form.Item>
              </div>
              <div className="w-full">
                <Form.Item
                  className="sm:me-4"
                  label="Sub Total"
                  name="subTotal"
                >
                  <Input placeholder="Sub Total" type="number" disabled />
                </Form.Item>
              </div>
              <div className="w-full">
                <Form.Item label="Total GST" name="totalGST">
                  <Input placeholder="Total GST" type="number" disabled />
                </Form.Item>
              </div>
            </div>
            <div className="w-full sm:flex">
              <div className="w-full">
                <Form.Item
                  className="sm:me-4"
                  label="Grand Total"
                  name="grandTotal"
                  validateStatus={gtError ? "error" : ""}
                  help={gtError}
                >
                  <Input placeholder="Grand Total" type="number" disabled />
                </Form.Item>
              </div>
              <div className="w-full">
                <Form.Item
                  className="sm:me-4"
                  label="Payment Method"
                  name="payment_method"
                >
                  <Input placeholder="Payment Method" disabled />
                </Form.Item>
              </div>
              <div className="w-full mx-2">
                <Form.Item label="Balanced Credit Limit" name="balance_credit">
                  <Input placeholder="Balanced Credit Limit" disabled />
                </Form.Item>
              </div>
            </div>
          </div>

          <div className="flex justify-between items-center w-full mt-4">
            <Button
              className="text-md rounded-lg"
              onClick={handlePrevious}
              disabled={props.currentStep <= 0}
            >
              <LeftCircleOutlined className="mb-[-3px]" /> PREVIOUS
            </Button>
            <div>
              <Button
                className="text-md rounded-lg mr-4"
                type="primary"
                htmlType="submit"
                onClick={handleDraft}
              >
                SAVE DRAFT
              </Button>
              <Button
                className="text-md rounded-lg"
                type="primary"
                // htmlType="submit"
                disabled={disabledSubmit}
                onClick={handleSubmit}
              >
                Submit <RightCircleOutlined className="mb-[-3px]" />
              </Button>
            </div>
          </div>
        </Form>
      </div>
    </>
  );
};

export default ProductAndPaymentDuplicate;
